__turbopack_context__.v({
  "QRWrapper": "VPadPairingModal-module__bzZW3W__QRWrapper",
  "QR__image": "VPadPairingModal-module__bzZW3W__QR__image",
  "QR_code": "VPadPairingModal-module__bzZW3W__QR_code",
  "betaText": "VPadPairingModal-module__bzZW3W__betaText",
  "closeBtnWrapper": "VPadPairingModal-module__bzZW3W__closeBtnWrapper",
  "code": "VPadPairingModal-module__bzZW3W__code",
  "codeWrapper": "VPadPairingModal-module__bzZW3W__codeWrapper",
  "content": "VPadPairingModal-module__bzZW3W__content",
  "contentStep": "VPadPairingModal-module__bzZW3W__contentStep",
  "contentWrapper": "VPadPairingModal-module__bzZW3W__contentWrapper",
  "infoIcon": "VPadPairingModal-module__bzZW3W__infoIcon",
  "networkContent": "VPadPairingModal-module__bzZW3W__networkContent",
  "networkIcon": "VPadPairingModal-module__bzZW3W__networkIcon",
  "networkWrapper": "VPadPairingModal-module__bzZW3W__networkWrapper",
  "numStep": "VPadPairingModal-module__bzZW3W__numStep",
  "priorityGamepadContent": "VPadPairingModal-module__bzZW3W__priorityGamepadContent",
  "priorityGamepadWrapper": "VPadPairingModal-module__bzZW3W__priorityGamepadWrapper",
  "step1_image": "VPadPairingModal-module__bzZW3W__step1_image",
  "step2_image": "VPadPairingModal-module__bzZW3W__step2_image",
  "step3": "VPadPairingModal-module__bzZW3W__step3",
  "step3_content": "VPadPairingModal-module__bzZW3W__step3_content",
  "step3_image": "VPadPairingModal-module__bzZW3W__step3_image",
  "stepCard": "VPadPairingModal-module__bzZW3W__stepCard",
  "stepContent": "VPadPairingModal-module__bzZW3W__stepContent",
  "stepDescription": "VPadPairingModal-module__bzZW3W__stepDescription",
  "steps": "VPadPairingModal-module__bzZW3W__steps",
  "vpadPairingModal": "VPadPairingModal-module__bzZW3W__vpadPairingModal",
});
